import billingApi from '../services/billingApi';

let cachedPublishableKey = null;

function getRuntimeConfig() {
  if (typeof window !== 'undefined' && window.__RETECHSYS_RUNTIME_CONFIG__) {
    return window.__RETECHSYS_RUNTIME_CONFIG__;
  }
  return {};
}

/** @returns {'live' | 'test' | 'unknown'} */
export function getStripeKeyMode(publishableKey) {
  if (!publishableKey) return 'unknown';
  if (publishableKey.startsWith('pk_live_')) return 'live';
  if (publishableKey.startsWith('pk_test_')) return 'test';
  return 'unknown';
}

/**
 * Publishable key from runtime config or CRA build env.
 */
export function getBuildTimePublishableKey() {
  const runtime = getRuntimeConfig();
  if (runtime.stripePublishableKey) {
    return runtime.stripePublishableKey;
  }
  return process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';
}

/**
 * Resolve Stripe publishable key: API (Lambda) → runtime file → CRA build env.
 * API is preferred so a live pk_live on Lambda overrides a stale pk_test in runtime-config.js.
 */
export async function resolveStripePublishableKey() {
  if (cachedPublishableKey) {
    return cachedPublishableKey;
  }

  try {
    const config = await billingApi.getConfig();
    if (config.stripePublishableKey) {
      cachedPublishableKey = config.stripePublishableKey;
      return cachedPublishableKey;
    }
  } catch (err) {
    console.warn('Could not load Stripe config from API:', err.message);
  }

  const buildTimeKey = getBuildTimePublishableKey();
  if (buildTimeKey) {
    cachedPublishableKey = buildTimeKey;
    return cachedPublishableKey;
  }

  return '';
}

/** Clear cache after deploy / config change (e.g. hard refresh helper). */
export function clearStripePublishableKeyCache() {
  cachedPublishableKey = null;
}

export function stripeTestModeErrorMessage() {
  return (
    'Stripe is still in test mode (pk_test_). Real cards only work with live keys (pk_live_). ' +
    'Update server/.env and Lambda STRIPE_PUBLISHABLE_KEY, run npm run stripe:sync-env, redeploy the API, then hard-refresh.'
  );
}

/** True on production site — block pk_test + real cards there only. */
export function isProductionAppHost() {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'retechsys.ai' || host === 'www.retechsys.ai';
}
